/**
 * Evidence facts and badges are data on the server (their labels too), so
 * the KYB pages look the wording up instead of translating keys.
 */
import { useMemo } from "react";
import type { EvidenceFact, VerificationBadge } from "@/services/moderators/generated/model";
import {
  useVerificationModeratorBadgesFactsList,
  useVerificationModeratorBadgesList,
} from "@/services/moderators/generated/moderators-verification/moderators-verification";

export function useFactLabels(): (key: string) => string {
  const { data } = useVerificationModeratorBadgesFactsList();
  return useMemo(() => {
    const map = new Map((data as EvidenceFact[] | undefined)?.map((f) => [f.key, f.label]) ?? []);
    return (key: string) => map.get(key) ?? key;
  }, [data]);
}

export function useBadgeLabels(): (key: string) => string {
  const { data } = useVerificationModeratorBadgesList();
  return useMemo(() => {
    const map = new Map((data as VerificationBadge[] | undefined)?.map((b) => [b.key, b.label]) ?? []);
    return (key: string) => map.get(key) ?? key;
  }, [data]);
}
